import { Component, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { ResultStatus } from "@app/core/models/result-status";
import { HelperService } from "@app/core/services/helper.service";
import { MessageCenterService } from "@app/core/services/message-center.service";
import { AgentDetailComponent } from '@app/modules/agent/pages/agent-detail/agent-detail.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: "app-inbox-message-detail",
  templateUrl: "./inbox-message-detail.component.html",
  styleUrls: ["./inbox-message-detail.component.scss"],
})
export class InboxMessageDetailComponent implements OnInit, OnDestroy {
  messageDetail;
  isDataLoaded = false;
  messageId: any;
  bsModalRef: BsModalRef;
  public displayHeader = false;

  constructor(
    private messageCenterService: MessageCenterService,
    private sanit: DomSanitizer,
    private helperService: HelperService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private router: Router
  ) {
    this.activatedRoute.params.subscribe((param) => {
      if (!this.helperService.isUndefinedOrNullOrEmpty(param.id)) {
        this.messageId = param.id;
      }
    });
  }

  ngOnInit() {
    if (!this.helperService.isUndefinedOrNullOrEmpty(this.messageId)) {
      this.getMessages();
    }
  }

  getMessages() {
    this.messageCenterService
      .getMessagesById(this.messageId)
      .subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          this.isDataLoaded = true;
          this.messageDetail = result.Data;
        } else {
          this.messageDetail = null;
        }
      });
  }

  openModalWithComponent(agentID) {
    if (agentID > 0) {
      const initialState = {
        agentId: agentID,
      };

      this.bsModalRef = this.modalService.show(AgentDetailComponent, {
        initialState,
        backdrop: 'static',
        class: "modal-xl",
      });
      this.bsModalRef.content.closeBtnName = "Close";
    }
  }

  ngOnDestroy() {
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  back() {
    this.router.navigate([`/inbox`]);
  }
}
